import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import ImageGallery from '../components/ImageGallery';
import { projectAPI } from '../services/api';

const FinishedProjectImagesPage = () => {
  const { projectId } = useParams();

  // Fetch basic project details for the title
  const { 
    data: projectResponse, 
    isLoading, 
    error 
  } = useQuery({
    queryKey: ['finished-project-basic', projectId],
    queryFn: () => projectAPI.getById(projectId),
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000
  });

  const project = projectResponse?.data;

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-gray-300 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (error || !project) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400">Project not found or error loading.</p>
        </div>
      </div>
    );
  }

  return (
    <ImageGallery
      apiFunction={projectAPI.getImages}
      projectId={projectId}
      project={project}
      title={`${project.name}`}
      backPath={`/projects/${projectId}`}
      backLabel="Back to project"
    />
  );
};

export default FinishedProjectImagesPage;
